import React from 'react';

const SwitchOperation = ({ formData, updateFormData, nextStep, prevStep, currentStep, totalSteps }) => {
  const handleSwitchChange = (switchName, field, value) => {
    const newSwitchData = { ...formData[switchName], [field]: value };
    updateFormData({ [switchName]: newSwitchData });
  };

  // Check if model is one of the specified models that should not show Results column
  const shouldHideResults = formData.model && (
    formData.model === '4031-OTI' || 
    formData.model === '4031-WTI' || 
    formData.model === '4031H-OTI' || 
    formData.model === '4031H-WTI'
  );

  return (
    <div className="form-section">
      <h3>Switch Operation Reading</h3>
      
      <div className="table-container">
        <table className="test-table">
          <thead>
            <tr>
              <th style={{ width: '50px' }}>No.</th>
              <th>Switch Name</th>
              <th>S1</th>
              {!shouldHideResults && <th>Result</th>}
              <th>S2</th>
              {!shouldHideResults && <th>Result</th>}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ textAlign: 'center', fontWeight: 'bold' }}>1</td>
              <td><strong>Switch Set Point in °C</strong></td>
              <td>
                <input
                  type="number"
                  value={formData.s1.setPoint}
                  onChange={(e) => handleSwitchChange('s1', 'setPoint', e.target.value)}
                  placeholder="80"
                />
              </td>
              {!shouldHideResults && <td><strong>Pass</strong></td>}
              <td>
                <input
                  type="number"
                  value={formData.s2.setPoint}
                  onChange={(e) => handleSwitchChange('s2', 'setPoint', e.target.value)}
                  placeholder="90"
                />
              </td>
              {!shouldHideResults && <td><strong>Pass</strong></td>}
            </tr>
            <tr>
              <td style={{ textAlign: 'center', fontWeight: 'bold' }}>2</td>
              <td><strong>Switch On at in °C</strong></td>
              <td>
                <input
                  type="number"
                  value={formData.s1.onAt}
                  onChange={(e) => handleSwitchChange('s1', 'onAt', e.target.value)}
                  placeholder="80"
                />
              </td>
              {!shouldHideResults && <td></td>}
              <td>
                <input
                  type="number"
                  value={formData.s2.onAt}
                  onChange={(e) => handleSwitchChange('s2', 'onAt', e.target.value)}
                  placeholder="90"
                />
              </td>
              {!shouldHideResults && <td></td>}
            </tr>
            <tr>
              <td style={{ textAlign: 'center', fontWeight: 'bold' }}>3</td>
              <td><strong>Switch Off at in °C</strong></td>
              <td>
                <input
                  type="number"
                  value={formData.s1.offAt}
                  onChange={(e) => handleSwitchChange('s1', 'offAt', e.target.value)}
                  placeholder="77"
                />
              </td>
              {!shouldHideResults && <td></td>}
              <td>
                <input
                  type="number"
                  value={formData.s2.offAt}
                  onChange={(e) => handleSwitchChange('s2', 'offAt', e.target.value)}
                  placeholder="87"
                />
              </td>
              {!shouldHideResults && <td></td>}
            </tr>
            <tr>
              <td style={{ textAlign: 'center', fontWeight: 'bold' }}>4</td>
              <td><strong>Switch Differential observed in °C</strong></td>
              <td>
                <input
                  type="number"
                  value={formData.s1.differential}
                  onChange={(e) => handleSwitchChange('s1', 'differential', e.target.value)}
                  placeholder="3"
                />
              </td>
              {!shouldHideResults && <td></td>}
              <td>
                <input
                  type="number"
                  value={formData.s2.differential}
                  onChange={(e) => handleSwitchChange('s2', 'differential', e.target.value)}
                  placeholder="3"
                />
              </td>
              {!shouldHideResults && <td></td>}
            </tr>
          </tbody>
        </table>
      </div>

      <div className="navigation-buttons">
        <button 
          className="btn btn-secondary" 
          onClick={prevStep}
          disabled={currentStep === 1}
        >
          Previous
        </button>
        <button 
          className="btn btn-primary" 
          onClick={nextStep}
          disabled={currentStep === totalSteps}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default SwitchOperation;
